import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";
import { useState } from "react";

export default function useAttendance() {
  const { api, AdminId } = useGlobalContext();

  const [loading, setLoading] = useState(false);

  const shouldShowLocalError = (data) => {
    return (
      data?.responseCode !== "00" &&
      data?.responseCode !== "02" &&
      data?.responseCode !== "03" &&
      data?.responseCode !== "98" &&
      data?.responseCode !== "401"
    );
  };

  /* FETCH ATTENDANCE RECORD */

  const fetchAttendanceApi = async (
    payload,
    setDrivers,
    setDirtyMap,
    setPageLoading
  ) => {
    setPageLoading(true);
    setDirtyMap({});

    try {
      const body = {
        adminId: String(AdminId),
        driverCode: payload.driverCode || "",
        fromDate: payload.fromDate,
        toDate: payload.toDate,
      };

      const res = await api.post(
        "/api/Driver/v1.0/getDriverAttendanceRecord",
        body
      );

      if (res?.data?.responseCode === "00") {
        const serverData = res.data.data || [];

        const normalized = serverData.map((d) => {
          const map = {};

          (d.attendance || []).forEach((a) => {
            if (a?.date && a?.status) {
              map[a.date] = a.status;
            }
          });

          return { ...d, attendanceMap: map };
        });

        setDrivers(normalized);
        return normalized;
      }

      if (shouldShowLocalError(res?.data)) {
        toast.error(res?.data?.responseMessage || "Failed to fetch attendance");
      }

      setDrivers([]);
      return [];
    } catch (err) {
      console.error("fetchAttendanceApi error:", err);
      toast.error("Error fetching attendance");
      setDrivers([]);
      return [];
    } finally {
      setPageLoading(false);
    }
  };

  /* UPDATE ATTENDANCE */

  const updateAttendanceApi = async (dirtyData, setDirtyMap) => {
    if (!dirtyData || dirtyData.length === 0) {
      toast.message("No changes to save");
      return false;
    }

    setLoading(true);

    try {
      const payload = {
        adminId: String(AdminId),
        data: dirtyData,
      };

      const res = await api.post(
        "/api/Driver/v1.0/updateDriverAttendanceRecord",
        payload
      );

      if (res?.data?.responseCode === "00") {
        toast.success(res.data.responseMessage || "Attendance updated");
        setDirtyMap({});
        return true;
      }

      if (shouldShowLocalError(res?.data)) {
        toast.error(res?.data?.responseMessage || "Update failed");
      }

      return false;
    } catch (err) {
      console.error("updateAttendanceApi error:", err);
      toast.error("Error updating attendance");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchAttendanceApi,
    updateAttendanceApi,
    loading,
  };
}